import React, { useState } from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import StyledHelpMenu from "@icarius-common/styledMenu";
import MenuItemWithIcon from "@icarius-common/MenuItemWithIcon";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";

export const helpItems = [
  {
    title: "icariusTech",
    type: 'video',
    value: "https://www.youtube.com/embed/GeXPlbMMeAs",
  },
  {
    title: "notes",
    type: 'video',
    value: "https://www.youtube.com/embed/oY6-PGWBYvQ",
  },
  {
    title: "pollSliderTitle",
    type: 'video',
    value: 'https://www.youtube.com/embed/gvm4lL3KZlo',
  },
  {
    title: "accessByGroups",
    type: 'video',
    value: 'https://www.youtube.com/embed/AS8LUsd6W9w',
  },
  {
    title: "tasksAndTelecommuting",
    type: 'video',
    value: 'https://www.youtube.com/embed/WAu2ZEPvNgk',
  },
  {
    title: "digitalSignature",
    type: 'video',
    value: 'https://www.youtube.com/embed/kDrBI7MB0GM',
  },
]

const Help = React.memo(() => {

  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <>
      <CustomIconButton
        noBorder
        type={'help'}
        title={getLocalizedString("help")}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      />
      <StyledHelpMenu
        anchorEl={anchorEl}
        isOpen={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {
          helpItems.map((item, index) => {
            return (
              <MenuItemWithIcon
                key={index}
                value={item.value}
                text={getLocalizedString(item.title)}
                type={item.type}
              />
            )
          })
        }
      </StyledHelpMenu>
    </>
  );
})

export default Help;
